import { Component, OnInit } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import 'moment-timezone';
import { Location } from '@angular/common';
import { SubSink } from 'subsink';

import { LoginComponent } from '../../login/login.component';
import { PromovideoComponent } from '../../promovideo/promovideo.component';
import { StorageService } from '../../shared/services/storage.service';
import { AppStorage, StreamType } from '../../providers/enum';
import { LoginService } from '../../login/login.service';
import { ActivatedRoute, Router } from '@angular/router';
import { DomainHomePageService } from './services/domain-home-page.service.js';

@Component({
  selector: 'app-domain-home-page',
  templateUrl: './domain-home-page.component.html',
  styleUrls: ['./domain-home-page.component.scss']
})
export class DomainHomePageComponent implements OnInit {

  //#region variables

  public handler: any = null;
  public errorMessage: string;
  public paymentSuccess = false;
  public modalRef: BsModalRef;
  public userData: any;
  public streamDetails: any;
  public streamDescFull: any;
  public textBelowPoster: any;
  public streamDetailsFull: any;
  public isUserLogin: boolean = false;
  public isWatchWithAccessCodeClick: boolean = false;
  public isTimeLeftLessOrEqual15: boolean;
  public isLiveEventBuyed: string;
  public viewEventFlag: boolean;
  public DomainName: string;
  public currentTimeZone: string;
  public isPaymentDisable: boolean = false;
  public isWatchEventDisable: boolean = false;
  public showLoading: boolean = true;
  public channelButtonActive = false;
  public extraButtonActive = false;
  public timerInterval: any;
  public contentBackground: string;
  public domain: string;
  public isURLSuccess: boolean = false;
  public isURLCancel: boolean = false;
  public timeDiff;
  public loginButtonActive = true;
  public paymentButtonActive = true;
  public watcheventButtonActive = true;
  public resendButtonActive = true;
  public eventCounterShow = true;
  public myAngularxQrCode: string = null;
  public eventFooterLink = true;
  public textAboveButtonActive = true;
  public streamType: StreamType;
  public isEventStart: boolean = false;
  public stream_addthis_id: string;
  public contentBackgroundStyle: string;
  public promoLinkActive: boolean;
  public iosAppAvailable: boolean;
  public androidAppAvailable: boolean;
  public streamCorrect: boolean;
  public clientDetails1: any;
  public clientDetailsLocal: any;
  public appDetailsHP: any;
  public appDesignHP: any;
  public swigitsHP: any;
  public appBundlesHP: any;
  private subs = new SubSink();
  public siteDomainHP: string;
  public isClientPage: boolean = true;
  public stripeAPIPubKeyLS: string;
  public stripeAPITokenKeyLS: string;
  public paymentModeV: string;
  public bundlePrice: any;

  //#endregion

  //#region life-cycle methods

  constructor(private router: Router,
    private route: ActivatedRoute,
    private modalService: BsModalService,
    private storageService: StorageService,
    private loginService: LoginService,
    private location: Location,
    private domainHomePageService: DomainHomePageService,) {

    let clientDetails = this.storageService.get(AppStorage.clientDetails, true);
    this.clientDetailsLocal = JSON.parse(clientDetails);
    //console.log('this.clientDetailsLocal: ', this.clientDetailsLocal);
    this.appDetailsHP = this.clientDetailsLocal.data.appDetails;
    this.appDesignHP = this.clientDetailsLocal.data.appDesigns;
    this.swigitsHP = this.clientDetailsLocal.data.swigits;
    let SwigitHPVar = this.clientDetailsLocal.data.swigits;
    this.appBundlesHP = this.clientDetailsLocal.data.appBundles;
    this.isClientPage = this.clientDetailsLocal.ClientPageVar;

    Array.from(SwigitHPVar, child => {
      //   console.log("ddd=",child)
    });

    //console.log("ookkkkkk");

    this.siteDomainHP = this.storageService.get(AppStorage.siteDomain, true);

    //This code for Live 
    let apptitlel = this.route.snapshot.params.url;
    if (apptitlel === 'success') {
      this.isURLSuccess = true;
      this.isURLCancel = false;
    } else if (apptitlel === 'cancel') {
      this.isURLSuccess = false;
      this.isURLCancel = true;
    }

    // This code for localhost
    this.route.queryParams.subscribe(params => {
      // console.log("params=", params);
      if (params && params.url) {
        if (apptitlel === 'success') {
          this.isURLSuccess = true;
          this.isURLCancel = false;
        } else if (apptitlel === 'cancel') {
          this.isURLSuccess = false;
          this.isURLCancel = true;
        }
      }
    }, (error: any) => {
      // console.log('error: ', error);
    });
  }

  ngOnInit(): void {

    let data = this.storageService.get(AppStorage.data, true);
    this.userData = JSON.parse(data);
    this.paymentModeV = this.clientDetailsLocal.data.appDetails.app_payment_mode;

    if (this.paymentModeV === 'L') {
      this.stripeAPIPubKeyLS = this.clientDetailsLocal.data.appDetails.app_stripe_API_pubkey_live;
      this.stripeAPITokenKeyLS = this.clientDetailsLocal.data.appDetails.app_stripe_API_token_live;
    }
    else if (this.paymentModeV === 'T') {
      this.stripeAPIPubKeyLS = this.clientDetailsLocal.data.appDetails.app_stripe_API_pubkey_test;
      this.stripeAPITokenKeyLS = this.clientDetailsLocal.data.appDetails.app_stripe_API_token_test;
    }

  }

  //#endregion

  //#region private methods

  private openLoginModal(): void {
    this.modalRef = this.modalService.show(
      LoginComponent,
      Object.assign({ ignoreBackdropClick: true }, { class: 'gray modal-md' })
    );
  }

  //#endregion

  //#region public methods

  public onPromoBtnClick(streamURL: any): void {
    let initialState = { url: streamURL };
    this.modalRef = this.modalService.show(
      PromovideoComponent,
      Object.assign({ ignoreBackdropClick: true }, { class: 'gray fullHeight modal-lg', initialState })
    );
  }

  public onImageClick() {
    //console.log('das');
    this.router.navigate([`bundle`]);
  }

  public finalpay(price) {
    if (this.userData && this.userData.userCode) {
      this.pay(price);
    } else {
      this.openLoginModal();
    }
  }

  public pay(price) {

    var formDataG = new FormData();
    formDataG.append('stripe_key', 'sk_test_Lr0VtmNnhemHch6IUvauT4dI')
    formDataG.append('payment_method_types', 'card')
    formDataG.append('product', 'prod_MGxp6FssXuritG')
    formDataG.append('unit_amount', '1500')
    formDataG.append('currency', 'usd')
    formDataG.append('success_url', 'http://localhost:4200/?domain=dancestar&url=success')
    formDataG.append('cancel_url', 'http://localhost:4200/?domain=dancestar&url=cancel')

    this.subs.sink = this.domainHomePageService.purchaseBundleByUser(formDataG).subscribe(
      (response: any) => {
        // console.log('response email: ', response);
        if (response.url) {
          window.open(response.url, "_self");
        }
        // if (response.status === 0) {
        //   this.errorMessage =
        //     "Oops something went wrong please try again later.";
        // } else {
        //   this.errorMessage = response.msg;
        // }
        this.showLoading = false;
      },
      (error) => {
        //console.log('error: ', error);
        this.errorMessage = "oops something went wrong please try again later.";
        this.showLoading = false;
      }
    );
  }

  //#endregion

}

